// modal.ts

class Modal {
    private modals: NodeListOf<HTMLElement>;
    private openButtons: NodeListOf<HTMLElement>;
    private closeButtons: NodeListOf<HTMLElement>;

    constructor() {
        this.modals = document.querySelectorAll('.modal');
        this.openButtons = document.querySelectorAll('.open-modal');
        this.closeButtons = document.querySelectorAll('.close-modal');

        // Инициализация
        this._init();
    }

    private _init(): void {
        document.addEventListener('click', (e: Event) => {
            const target = e.target as HTMLElement;

            // открыть
            const openBtn = target.closest('.open-modal') as HTMLElement;
            if (openBtn) {
                const modalId = openBtn.getAttribute('data-modal');
                if (modalId) this.open(modalId);
            }

            // закрыть кнопкой
            if (target.closest('.close-modal')) {
                this.close();
            }

            // клик вне модалки
            const modal = target.closest('.modal') as HTMLElement;
            if (modal && target === modal) {
                this.close();
            }
        });

        document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Escape') this.close();
        });
    }


    // Открытие модалки по ID
    public open(modalId: string): void {
        // Закрываем все модалки перед открытием новой
        this.close();

        const modal = document.getElementById(modalId);
        if (modal) {
            modal.classList.add('show');
            document.body.classList.add('modal-open');
        }
    }

    // Закрытие всех модалок
    public close(modalId?: string): void {
        if (modalId) {
            const modal = document.getElementById(modalId);
            modal?.classList.remove('show');
        } else {
            this.modals.forEach(m => m.classList.remove('show'));
        }

        const anyOpen = document.querySelector('.modal.show');
        if (!anyOpen) {
            document.body.classList.remove('modal-open');
        }
    }

}

// Экспортируем модалку для использования в других частях приложения
export const modal = new Modal();
window.modal = modal;
